import {command} from './api'
export const unstickIO={write:(action:string,payload:Record<string,unknown>)=>command(action,payload,true)}
